<script setup>
  import { computed } from 'vue';
  import useHomeConfiguration from '@/composables/useHomeConfiguration';
  import featWeatherStations from '@/assets/images/home/feat-weatherstations.png';
  import featWeatherForecasts from '@/assets/images/home/feat-weatherforecasts.png';
  import featLiveWind from '@/assets/images/home/feat-onsitereports.png';

  const { $FEATURES } = useHomeConfiguration();

  // Bundled copies of the legacy ~/App_Themes/Common/images/images/feat-*.png,
  // served from the JWX CDN so they resolve on every brand and in dev.
  const featureImages = {
    1: featWeatherStations,
    2: featWeatherForecasts,
    3: featLiveWind
  };

  const props = defineProps({
    featureId: {
      type: Number,
      required: true
    }
  })

  const feature = computed(() => $FEATURES.find((f) => f.id === props.featureId));
</script>

<template>
  <!-- Legacy Homepage.master .feature block, ids and classes preserved -->
  <div class="feature">
    <div v-if="feature" :id="`features-${feature.id}`" class="feature-item">
      <div class="feature-text">
        <h2>{{ feature.heading }}</h2>
        <p>{{ feature.body }}</p>
      </div>
      <img :src="featureImages[feature.id]" :alt="feature.alt" class="feature-img" />
    </div>
  </div>
</template>

<style scoped>
  /* Ported from jweather-new-home-common.css */

  .feature {
    background-color: #fff;
    background-color: rgba(255, 255, 255, 0.9);
  }

  .feature-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    max-width: 960px;
    margin: 0 auto;
    min-height: 294px;
    box-sizing: border-box;
  }

  .feature-text {
    flex: 1;
    padding: 20px;
  }

  .feature-img {
    max-width: 400px;
    height: auto;
    margin-right: 20px;
  }

  .feature h2 {
    font-size: 30px;
    margin: 0 0 15px 0;
    padding: 50px 0 0 0;
  }

  .feature p {
    font-size: 15px;
    margin-top: 0;
  }
  
  @media only screen and (max-width: 767px) {
    .feature div {
      background-position: 120% 0;
      padding: 0 2rem;
    }

    .feature-item {
      min-height: auto;
    }

    .feature h2 {
      font-size: 30px;
      margin: 0 0 15px 0;
      padding: 2.25rem 0 0 0;
      line-height: 1.2;
    }    
  
    .feature p {
      line-height: 25px;
    }

    .feature-img {
      display: none;
    }
  }
</style>
